import { FC } from 'react';
import { ButtonRowButton } from '../ButtonRowButton';
import { BBButtonContainer } from '../styles';
import { useTranslations } from 'next-intl';

interface ButtonRowProps {
  buttons: { title: string; value: number | null }[];
  value: number | null | undefined;
  onChange: (value: number | null) => void;
  testIdType?: string;
}

export const ButtonRow: FC<ButtonRowProps> = ({ buttons, value, onChange, testIdType }) => {
  const t = useTranslations();

  return (
    <BBButtonContainer>
      {buttons.map((b) => (
        <ButtonRowButton
          key={b.value}
          dataTestId={`${b.title.toLowerCase()}-${testIdType}-btn`}
          name={t(b.title as any)}
          selected={b.value === value}
          onClick={() => onChange(b.value)}
        />
      ))}
    </BBButtonContainer>
  );
};
